import { fileProxyUrl } from '@/shared/utils/file-url'

export function videoPlaybackUrl(item: {
  video_file_storage_id?: number | null
  file_storage_id?: number | null
}): string {
  const storageId = item.video_file_storage_id || item.file_storage_id
  if (!storageId) return ''
  return fileProxyUrl(storageId)
}
